import React,{ useEffect, useState,useCallback} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Header from '../Navbar/page'
import Api from '../Api/Api';
import moment from 'moment';
// import Loader from '../loader'
import FooterSection from "../footer/page";
import { RingLoader } from "react-spinners";
import Sidenavar from '../Navbar/sideNav/page'

function Page() {
  const [TrasactionResp,setTrasactionResp]= useState([]);
  const [loading, setLoading] = useState(false);
  const[TotalPageData,setTotalPageData]= useState(0)
  const navigate = useNavigate()
  const usermongoId= localStorage.getItem("UserIdMongo")

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 

  const indexOfLastTransaction = currentPage * itemsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - itemsPerPage;
  // const currentTransactions = TrasactionResp.slice(indexOfFirstTransaction, indexOfLastTransaction);
  const currentTransactions = Array.isArray(TrasactionResp) 
  ? TrasactionResp.slice(indexOfFirstTransaction, indexOfLastTransaction) 
  : [];


  const clientid= localStorage.getItem("UserIdclient")

 const useridget= localStorage.getItem("userID")

 const datavalueLength=TrasactionResp.length ?? 0
 

  const handlePageChange = (pageNumber) => {
  
      const totalPages = Math.ceil(TotalPageData / itemsPerPage);
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
   
    // setCurrentPage(pageNumber > 0 ? pageNumber : 1);
    // console.log("page number",pageNumber)
  };

  

  const transactionData=async()=>{
    setLoading(true)
    try{
        const response = await Api.get(`/user/userRewards?userid=${usermongoId}&pageNumber=${currentPage}&pageSize=${itemsPerPage}`)
    //  console.log("Dattataat---->ttttt",response.data.result)
     setTrasactionResp(response.data.result.userData)
     setTotalPageData(response.data.result.total);
    }catch(error){
        console.log(error)
    }
    setLoading(false)
  } 
  useEffect(() => {
    transactionData()
  }, [currentPage])

  return (
    <>
      {/* <div className="layout has-sidebar fixed-sidebar fixed-header">
        <Sidenavar />
        <div className="layout">
          <main className="content">
            <Header /> */}
      {loading ? (
        <>
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "30%", marginBottom: "20%" }}
          >
            {/* <Loader/> */}
            <RingLoader color="rgb(50 92 213)" size="100" />
          </div>
        </>
      ) : (
        <>
          {/* <Header /> */}
          <div className="body-background">
            <section className="banner-section inner-banner position-relative about">
              <div className="shape-area">
                <img
                  src="/assets/images/abs-items/bubble.png"
                  className="shape-1"
                  alt="icon"
                />
                <img
                  src="/assets/images/abs-items/ellipse-7.png"
                  className="shape-2"
                  alt="icon"
                />
              </div>
              <div className="container position-relative">
                <div style={{ marginTop: "9%", cursor: "pointer" }}>
                  <i class="fa fa-arrow-left" onClick={() => navigate("/")}></i>
                </div>
                <div className="banner-content row justify-content-between">
                  <div className="col-lg-6 col-md-10">
                    <div className="main-content">
                      <h2 className="visible-slowly-bottom display-four mb-6">
                        My Rewards
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                    <div className="breadcrumb-area position-absolute end-0 bottom-0">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                          <li className="breadcrumb-item p-0 m-0">
                            <Link to="/">Home</Link>
                          </li>
                          <li
                            className="breadcrumb-item active"
                            aria-current="page"
                          >
                            My Rewards
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="authority bettor-ranking">
              <div className="container"> 

                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="table-section">
                      <div className="balance"></div>

                      <div className="table-responsive">
                        <table className="table cart-page__table">
                          <thead>
                            <tr>
                              <th className="th1">Reward Date</th>
                              <th className="th2">Amount</th>
                              <th className="th2">Type</th>
                              <th className="th2">Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* {loading ? ( */}
                            <tr>
                              <td></td>
                              <td></td> 
                              <td></td>
                              <td></td>
                            </tr>
                            {datavalueLength == 0 ? (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  You have not earned any rewards yet
                                </td>
                              </tr>
                            ) : (
                              TrasactionResp.map((item, index) => (
                                <tr key={index}>
                                  <td className="td1">
                                    {moment(item.createdAt).format(
                                      "YYYY-MM-DD"
                                    )}
                                  </td>
                                  <td className="td2 hover hover">
                                    ${item.rewardAmount}
                                  </td>
                                  <td className="td2 hover">
                                    {item.rewardStatus}
                                  </td>
                                  <td className="td2 hover">
                                    {item.rewardDetails} 
                                  </td> 
                                </tr>
                              ))
                            )} 
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="pok-pagination"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="500"
                data-aos-easing="ease-in"
              >
                <ul>
                  <li>
                    <a
                      href="#0"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <i className="fa-solid fa-angles-left"></i>
                    </a>
                  </li>

                  {Array.from(
                    {
                      length: Math.ceil(TrasactionResp.length / itemsPerPage),
                    },
                    (_, i) => (
                      <React.Fragment key={i}>
                        <li>
                          <a href="#0" onClick={() => handlePageChange(i + 1)}>
                            {currentPage}
                          </a>
                        </li>
                        {i === Math.floor(14 / 2) && (
                          <li>
                            <span>...</span>
                          </li>
                        )}
                      </React.Fragment>
                    )
                  )}
                  <li>
                    <a
                      href="#0"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={
                        currentPage ===
                        Math.ceil(TrasactionResp.length / itemsPerPage)
                      }
                    >
                      <i className="fa-solid fa-angles-right"></i>
                    </a>
                  </li>
                </ul>
                {/* <div className="toggle-pagination">
              <span>Page {currentPage} of {Math.round(TotalPageData / itemsPerPage)}  {TotalPageData}</span>
            </div> */}
              </div>
            </div>
          </div>
        </>
      )}
      {/* </main>
        </div>
      </div> */}
      <FooterSection />
    </>
  );
}

export default Page